// extracted by mini-css-extract-plugin
export default {"root":"WordCloud_root__NSpnW","content":"WordCloud_content__QUUaf","tips":"WordCloud_tips__lHCy0"};